<button
  class="px-4 py-2 text-xs transition rounded-full"
  [ngClass]="{
    'bg-project-2900 text-project-300': isSelected(tag, surtitleTagType),
    'bg-gray-100 text-gray-800 hover:bg-project-2900 hover:text-project-300':
      !isSelected(tag, surtitleTagType)
  }"
  (click)="onClick()"
>
  {{ tag.displayName }}
</button>
